export enum InsuranceProviderEnum {
  PULPO = 'PULPO',
  XPLORASSUR = 'XPLORASSUR',
}
